import { MessageCircle } from "lucide-react";
import { useWhatsApp } from "@/context/WhatsAppContext";

// Build a wa.me deep link. Portuguese 9-digit mobiles get the +351 prefix.
export function buildWaLink(phone, name, template) {
  if (!phone) return null;
  let digits = String(phone).replace(/\D/g, "");
  if (!digits) return null;
  if (digits.length === 9) digits = "351" + digits;
  const msg = (template || "").replace(/\{nome\}/gi, (name || "").trim());
  return `https://wa.me/${digits}?text=${encodeURIComponent(msg)}`;
}

export default function WhatsAppButton({ phone, name, size = 16, showLabel = false, className = "" }) {
  const { template } = useWhatsApp();
  if (!phone) return null;
  const href = buildWaLink(phone, name, template);
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-btn"
      onClick={(e) => e.stopPropagation()}
      title="Enviar mensagem no WhatsApp"
      className={`inline-flex items-center gap-1.5 text-[#25D366] hover:text-[#3ddb78] transition-colors ${className}`}
    >
      <MessageCircle style={{ width: size, height: size }} />
      {showLabel && <span className="text-xs">WhatsApp</span>}
    </a>
  );
}
